module.exports = __webpack_public_path__ + "img/ic-oldsmobile.f7d38b8c.png";